// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af434c70","239":"56619197","455":"13149c6d"}[chunkId] + ".chunk.js";
};